import apiClient from '../axios.js';

const WAREHOUSE_BASE = '/client/warehouses';
const INVENTORY_BASE = '/client/inventory';

export const warehouseService = {
  getWarehouses: (params = {}) => {
    return apiClient.get(WAREHOUSE_BASE, { params });
  },

  getWarehouseById: (id) => {
    return apiClient.get(`${WAREHOUSE_BASE}/${id}`);
  },

  createWarehouse: (data) => {
    return apiClient.post(WAREHOUSE_BASE, data);
  },

  updateWarehouse: (id, data) => {
    return apiClient.put(`${WAREHOUSE_BASE}/${id}`, data);
  },

  updateWarehouseStatus: (id, status) => {
    return apiClient.patch(`${WAREHOUSE_BASE}/${id}/status`, { status });
  },

  getWarehouseInventory: (warehouseId, params = {}) => {
    return apiClient.get(`${WAREHOUSE_BASE}/${warehouseId}/inventory`, { params });
  },

  getStockTransactions: (params = {}) => {
    return apiClient.get(`${INVENTORY_BASE}/transactions`, { params });
  },

  getStockTransactionBatches: (params = {}) => {
    return apiClient.get(`${INVENTORY_BASE}/transactions/batches`, { params });
  },

  getStockTransactionBatchDetail: (params = {}) => {
    return apiClient.get(`${INVENTORY_BASE}/transactions/batches/detail`, { params });
  },

  adjustInventory: (data) => {
    return apiClient.post(`${INVENTORY_BASE}/adjustments`, data);
  },

  /**
   * 依商品 ID 取得各規格的倉庫庫存加總
   * @param {string} productId
   * @param {string|null} warehouseId - 指定倉庫（null 代表加總全部）
   */
  getProductStockTotals: (productId, warehouseId = null) => {
    const params = { productId };
    if (warehouseId) params.warehouseId = warehouseId;
    return apiClient.get(`${WAREHOUSE_BASE}/product-stock-totals`, { params });
  },

  /**
   * 多倉庫庫存明細匯出查詢
   * @param {string[]|'all'} warehouseIds - 倉庫 ID 陣列，或 'all' 代表全部
   * @param {{ search?: string }} options
   */
  getInventoryExport: (warehouseIds = 'all', options = {}) => {
    const params = {};
    params.warehouseIds = warehouseIds === 'all' ? 'all' : warehouseIds.join(',');
    if (options.search) params.search = options.search;
    return apiClient.get(`${WAREHOUSE_BASE}/inventory-export`, { params });
  }
};

export const purchaseOrderService = {
  getPurchaseOrders: (params = {}) => {
    return apiClient.get(`${INVENTORY_BASE}/purchase-orders`, { params });
  },

  getPurchaseOrderById: (id) => {
    return apiClient.get(`${INVENTORY_BASE}/purchase-orders/${id}`);
  },

  createPurchaseOrder: (data) => {
    return apiClient.post(`${INVENTORY_BASE}/purchase-orders`, data);
  },

  confirmPurchaseOrder: (id) => {
    return apiClient.post(`${INVENTORY_BASE}/purchase-orders/${id}/confirm`);
  },

  receivePurchaseOrder: (id, items) => {
    return apiClient.post(`${INVENTORY_BASE}/purchase-orders/${id}/receive`, { items });
  },

  cancelPurchaseOrder: (id) => {
    return apiClient.patch(`${INVENTORY_BASE}/purchase-orders/${id}/cancel`);
  }
};

export const transferOrderService = {
  getTransferOrders: (params = {}) => {
    return apiClient.get(`${INVENTORY_BASE}/transfer-orders`, { params });
  },

  getTransferOrderById: (id) => {
    return apiClient.get(`${INVENTORY_BASE}/transfer-orders/${id}`);
  },

  createTransferOrder: (data) => {
    return apiClient.post(`${INVENTORY_BASE}/transfer-orders`, data);
  },

  confirmTransferOrder: (id) => {
    return apiClient.post(`${INVENTORY_BASE}/transfer-orders/${id}/confirm`);
  },

  shipTransferOrder: (id, items) => {
    return apiClient.post(`${INVENTORY_BASE}/transfer-orders/${id}/ship`, { items });
  },

  receiveTransferOrder: (id, items) => {
    return apiClient.post(`${INVENTORY_BASE}/transfer-orders/${id}/receive`, { items });
  },

  cancelTransferOrder: (id) => {
    return apiClient.patch(`${INVENTORY_BASE}/transfer-orders/${id}/cancel`);
  }
};
